import styled from 'styled-components';

export const HeadingCourseName = styled.span`
  font-style: italic;
`;
